// src/vendors.ts
var Twitter = 23;
var Amplitude = 17;
var LinkBy = 18;
var Chartbeat = 22;

// src/index.ts
var nonIABVendorConsents = {};
var purposeConsents = {};
var isGDPR = false;
var defaultPurposes = Array.from({ length: 11 }, (_, i) => i + 1);
var { resolveConsentSignal, consentSignalPromise } = (() => {
  let resolveConsentSignal2;
  const consentSignalPromise2 = new Promise((resolve) => {
    resolveConsentSignal2 = resolve;
  });
  return { resolveConsentSignal: resolveConsentSignal2, consentSignalPromise: consentSignalPromise2 };
})();
var nonIABEventCallback = (nonIABData, success) => {
  if (((input) => {
    const $io0 = (input2) => typeof input2.gdprApplies === "boolean" && (input2.metadata === undefined || typeof input2.metadata === "string") && (typeof input2.nonIabVendorConsents === "object" && input2.nonIabVendorConsents !== null && Array.isArray(input2.nonIabVendorConsents) === false && $io1(input2.nonIabVendorConsents));
    const $io1 = (input2) => Object.keys(input2).every((key) => {
      const value = input2[key];
      if (value === undefined)
        return true;
      if (typeof Number(key) === "number")
        return typeof value === "boolean";
      return true;
    });
    return typeof input === "object" && input !== null && $io0(input);
  })(nonIABData)) {
    if (!success) {
      console.error("Non-IAB - failed to process getNonIABVendorConsents command");
    }
    const { nonIabVendorConsents, gdprApplies } = nonIABData;
    isGDPR = gdprApplies;
    nonIABVendorConsents = nonIabVendorConsents;
  } else {
    console.error("Non-IAB - invalid data received");
  }
};
var consentSignalReady = (tcData) => {
  const { gdprApplies, cmpStatus, tcString } = tcData;
  return !!(cmpStatus === "loaded" && gdprApplies && tcString);
};
var tcfEventCallback = (tcData, success) => {
  if (!success) {
    console.error("Non-IAB - failed to process addEventListener command");
  }
  if (tcData.cmpStatus === "error") {
    console.error("Non-IAB - CMP error");
  }
  const { purpose } = tcData;
  if (((input) => {
    const $io0 = (input2) => Object.keys(input2).every((key) => {
      const value = input2[key];
      if (value === undefined)
        return true;
      if (typeof Number(key) === "number")
        return typeof value === "boolean";
      return true;
    });
    return typeof input === "object" && input !== null && Array.isArray(input) === false && $io0(input);
  })(purpose?.consents)) {
    purposeConsents = purpose.consents;
  }
  globalThis.__tcfapi("getNonIABVendorConsents", 2, nonIABEventCallback);
  if (consentSignalReady(tcData)) {
    resolveConsentSignal();
  }
};
var hasPurposesConsented = (requiredPurposes) => {
  return requiredPurposes.every((purposeId) => purposeConsents[purposeId]);
};
var hasVendorConsented = (vendorId) => {
  return !!nonIABVendorConsents?.[vendorId];
};
var isNonIABVendorConsented = (vendorId, requiredPurposes = defaultPurposes) => {
  if (!isGDPR) {
    return true;
  }
  const vendorIds = Array.isArray(vendorId) ? vendorId : [vendorId];
  const allVendorsConsented = vendorIds.every(hasVendorConsented);
  const purposesConsented = hasPurposesConsented(requiredPurposes);
  return allVendorsConsented && purposesConsented;
};
var waitForNonIABVendorConsent = async (vendorId, purposes = defaultPurposes) => {
  await consentSignalPromise;
  return isNonIABVendorConsented(vendorId, purposes);
};
var waitForTCF = () => {
  return new Promise((resolve) => {
    const loop = () => typeof globalThis.__tcfapi === "function" ? resolve() : setTimeout(loop, 10);
    loop();
  });
};
var init = async () => {
  await waitForTCF();
  globalThis.__tcfapi("addEventListener", 2, tcfEventCallback);
};
init();
export {
  waitForNonIABVendorConsent,
  isNonIABVendorConsented,
  init,
  defaultPurposes,
  Twitter,
  LinkBy,
  Chartbeat,
  Amplitude
};

//# debugId=B01ABA8722112CD164756E2164756E21
